import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { createValidationError, PcsValidationErrors } from '@app/shared/validators/validation-errors';
import { getControls, isTrue } from '@util';
import * as R from 'ramda';

type NoneSelected = (controlNames: string[], controls: AbstractControl[]) => boolean;
const noneSelected: NoneSelected = (controlNames: string[], controls: AbstractControl[]) => {
  const requiredControls = R.map(name => controls[name], controlNames);
  return R.none(control => isTrue(control?.value), requiredControls);
};

export const requiredSelectionValidator = (controlNames: string[]) => (group: UntypedFormGroup): PcsValidationErrors => {
  const controls = getControls(group);
  return noneSelected(controlNames, controls)
    ? createValidationError('required', 'general.message.fieldRequired')
    : null;
};
